/* eslint-disable */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['swiper'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('swiper'));
  } else {
    // Browser globals
    root.SwiperExt = factory(root.Swiper);
  }
})(typeof self !== 'undefined' ? self : this, function (Swiper) {
  // Import the factory function
  const swiperExtInit = require('./swiper-ext');

  // Call the factory function passing Swiper
  return swiperExtInit(Swiper.default || Swiper);
});
/* eslint-enable */
